import React, { Component } from 'react'
import styled from 'styled-components'
import Title from './Title'

const Box = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 999;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

const Underlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  backdrop-filter: saturate(180%) blur(10px);
  background: rgba(225, 225, 225, 0.7);
  z-index: 997;
  cursor: pointer;
`

const CardBox = styled.div`
  background: #fff;
  border-radius: 10px;
  border: 1px solid var(--light-gray);
  overflow: hidden;
  box-shadow: 0 10px 20px var(--light-gray);
  width: 100%;
  max-width: 40rem;
  margin: auto;
  z-index: 998;
  position: relative;
  flex-shrink: 0;
`

export default class Card extends Component {
  render() {
    const { title, onClose, children } = this.props

    return (
      <Box>
        <Underlay onClick={onClose} />
        <CardBox>
          <Title str={title} onClose={onClose} />
          {children}
        </CardBox>
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js